import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Menu, MenuItem, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { InstalledAppCard } from '../InstalledAppCard';
import { selectProfile } from '../../actions/profile';

function AppManagerCard({ description, appLogo, onSelectProfile }) {
  const [anchor, setAnchor] = useState(null);
  const [redirectToHelp, setRedirectToHelp] = useState(false);
  const redirectUserToHelpPage = () => setRedirectToHelp(true);
  const open = ({ currentTarget }) => setAnchor(currentTarget);
  const close = action => () => {
    if (action) action();
    setAnchor(null);
  };
  return (
    <InstalledAppCard description={description} appLogo={appLogo}>
      <>
        {redirectToHelp ? <Redirect to="/help" /> : null}
        <Button variant="contained" color="primary" target="_blank" onClick={open}>
          Manage
        </Button>
        <Menu keepMounted anchorEl={anchor} open={!!anchor} elevation={10} onClose={close()}>
          <MenuItem onClick={close(onSelectProfile)}>Profile</MenuItem>
          <MenuItem onClick={close(redirectUserToHelpPage)}>Help</MenuItem>
        </Menu>
      </>
    </InstalledAppCard>
  );
}

AppManagerCard.propTypes = {
  description: PropTypes.string.isRequired,
  appLogo: PropTypes.node.isRequired,
  onSelectProfile: PropTypes.func.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    onSelectProfile: () => dispatch(selectProfile()),
  };
}

export const InstalledAppManagerCard = connect(() => ({}), mapDispatchToProps)(AppManagerCard);

export default InstalledAppManagerCard;
